// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zcuS","questions":"styles_questions__12f8S","footer":"styles_footer__1M25_"};